<template>
  <div class="filter">
    <!--选应用-->
    <div style="margin-right: 8px; z-index: 5">
      <Dropdown @on-click="selectApp" class="filter-appselecter">
        <i-button type="default" shape="circle" class="filter-appselecter-ctrl">
          <img v-if="selectedApp.icon" :src="selectedApp.icon" />
          <img v-if="!selectedApp.icon" />
          <span>{{ selectedApp.productname || '加载中...' }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </i-button>
        <Dropdown-menu slot="list" class="filter-appselecter-list">
          <Dropdown-item
            v-for="(item, index) in productList"
            :name="index"
            :key="index"
            class="filter-appselecter-item"
          >
            <img :src="item.icon" />
            <span class="filter-content" :title="item.productname">{{ item.productname }}</span>
          </Dropdown-item>
        </Dropdown-menu>
      </Dropdown>
    </div>
    <!--选平台(多选)-->
    <div style="z-index: 5">
      <Dropdown trigger="custom" :visible="platformShow" class="filter-platform" v-clickoutside="cancelPlatform">
        <i-button
          type="default"
          shape="circle"
          class="filter-platform-ctrl"
          style="padding: 0; padding-right: 20px; height: 36px; line-height: 32px; text-align: left; width: 100%"
          @click="openDropdown"
        >
          <Icon
            v-for="item in platChooseList"
            :key="item"
            :class="{ iconfont: true, [platformConst[item].icon]: true }"
            class="tm-platform-icon"
            style="font-size: 28px; color: #3091f2"
          ></Icon>
          <div style="position: absolute; top: 3px; right: 0">
            <Icon type="ios-arrow-down" style="margin-right: 8px"></Icon>
          </div>
        </i-button>
        <Dropdown-menu slot="list" class="filter-platform-list">
          <Checkbox-group v-model="platChooseList" style="width: 120px">
            <div v-for="item in platFullList" :key="item" style="height: 40px; line-height: 28px; padding: 6px">
              <Checkbox :label="platformConst[item].value">
                <Icon
                  :class="{ iconfont: true, [platformConst[item].icon]: true }"
                  class="tm-platform-icon"
                  style="font-size: 28px; color: #3091f2; float: left; margin-right: 8px"
                ></Icon>
              </Checkbox>
            </div>
          </Checkbox-group>
          <div style="margin: 8px 3px 2px; text-align: center">
            <i-button type="primary" size="small" @click="selectPlatform(undefined)" style="margin-right: 2px">{{
              $t('filter.confirm')
            }}</i-button>
            <i-button size="small" @click="cancelPlatform">{{ $t('filter.cancel') }}</i-button>
          </div>
        </Dropdown-menu>
      </Dropdown>
    </div>
    <!--选筛选-->
    <select-filter
      ref="globalFilter"
      style="flex-grow: 1"
      v-if="showCondition && selectedApp.productid"
      v-on:gob-change-condition="gobChangeCondition"
    >
    </select-filter>
    <!--选时间-->
    <div style="margi-right: 12px">
      <select-date v-if="showDate && selectedApp.productid" v-on:gob-change-date="gobChangeDate"></select-date>
    </div>
  </div>
</template>

<script>
import { directive as clickoutside } from 'v-click-outside-x';
import FilterConst from './FilterConst';
import SelectDate from './SelectDate';
import SelectFilter from './SelectFilter';
import AnalyticsPublic from '../../base/AnalyticsPublic';
import BaseLib from '../../base/BaseLib';
import StateHandler from '../../base/StateHandler';

export default {
  name: 'GlobalFilter',
  components: { SelectDate, SelectFilter },
  props: {
    ownProduct: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showDate: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showCondition: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  directives: {
    clickoutside,
  },
  data() {
    return {
      productList: [],
      selectedApp: {
        productid: AnalyticsPublic.productid,
        productname: AnalyticsPublic.productname,
        icon: '',
      },

      // 平台名称，平台图标
      platformConst: FilterConst.platformIcon,
      // 平台全量
      platFullList: AnalyticsPublic.platformFull,
      // 平台已选
      platChooseList: AnalyticsPublic.platform,
      // 变更对照
      pTTTList: AnalyticsPublic.platform,
      platformShow: false,
    };
  },
  methods: {
    // app 方法
    setProductObj(pObj, isChange) {
      this.selectedApp = pObj;

      this.$store.commit('setProductObj', pObj);

      this.platFullList = this.selectedApp.platform;
      if (isChange) {
        this.platChooseList = this.selectedApp.platform;
        this.pTTTList = this.selectedApp.platform;
        this.$nextTick(() => {
          const tmpObj = {
            productid: '' + pObj.productid,
            productname: pObj.productname,
            registertime: pObj.registertime,
            authorized: pObj.authorized,
            watchshow: pObj.watchshow,
            platformFull: pObj.platform,
            platform: pObj.platform,
            conditions: {
              partner: [],
              usergroup: [],
              version: [],
              newUserGroup: [],
            },
          };

          StateHandler.savePublic(tmpObj);

          this.$refs.globalFilter && this.$refs.globalFilter.clearSelect();

          BaseLib.postMessage('msg-change-product', pObj);
          this.$emit('gob-change-product', pObj);
          this.$emit('gob-change-any', 'product');

          this.resetPlatform(this.selectedApp.platform, true);
        });
      } else {
        this.$emit('gob-init-product', pObj);
        this.resetPlatform(this.selectedApp.platform);
      }
    },

    selectApp(index) {
      if (this.productList[index].productid === this.selectedApp.productid) return;
      // 批量选择拦截
      BaseLib.checkEmit(this.$root, 'check-change-product', {
        title: '切换应用提示',
        callback: () => {
          this.selectAppTrue(index);
        },
      });
    },
    selectAppTrue(index) {
      // 埋点
      const productInfo = this.productList[index];
      const productType = FilterConst.productType;
      const obj = {
        productName: productInfo.productname,
        productType: productType[`key${productInfo.productype}`],
      };
      if (window.TDAPP) {
        window.TDAPP.onEvent('accountloaded', '', obj);
      }

      this.setProductObj(this.productList[index], true);
    },
    fetchList() {
      let prodList = this.$store.state.productList;
      if (this.ownProduct) {
        prodList = this.$store.state.productOwnList;
      }
      this.productList = prodList || [];
      this.renderProduct();
    },
    renderProduct() {
      const tmpObj = this.productList.find(item => {
        return item.productid === parseInt(AnalyticsPublic.productid);
      });
      if (tmpObj) {
        this.setProductObj(tmpObj);
      }
    },
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, '');
    },
    // 平台方法
    openDropdown() {
      this.platformShow = true;
      this.pTTTList = this.platChooseList.concat();
    },
    resetPlatform(arrayParam, resetChoose) {
      this.platFullList = arrayParam;
      if (resetChoose) {
        this.platChooseList = arrayParam;
      }
    },
    selectPlatform() {
      // 批量选择拦截
      BaseLib.checkEmit(this.$root, 'check-change-platform', {
        title: '切换平台提示',
        callback: () => {
          this.selectPlatformTrue();
        },
      });
    },
    selectPlatformTrue() {
      if (this.platChooseList.length === 0) {
        this.$Message.destroy();
        this.$Message.warning({
          content: this.$t('filter.err'),
          duration: 5,
        });
        return;
      }
      this.platformShow = false;

      // 排序 todo
      AnalyticsPublic.platform.sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });
      this.platChooseList.sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });
      this.pTTTList.sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      });

      if (this.pTTTList.toString() !== this.platChooseList.toString()) {
        this.pTTTList = this.platChooseList;
        setTimeout(() => {
          AnalyticsPublic.platform = this.platChooseList;
          const conditions = {
            partner: [],
            usergroup: [],
            version: [],
            newUserGroup: [],
          };
          StateHandler.savePublic({ platform: this.platChooseList, conditions });
          BaseLib.postMessage('msg-change-platform', this.platChooseList);
          BaseLib.postMessage('msg-change-condition', conditions);

          this.$emit('gob-change-platform', this.platChooseList);
          this.$emit('gob-change-any', 'platform');
          this.$refs.filterCustomRef && this.$refs.filterCustomRef.clearAll();

          this.$refs.globalFilter && this.$refs.globalFilter.clearSelect();
        });
      }
    },
    cancelPlatform() {
      if (this.platformShow) {
        this.platformShow = false;
        this.platChooseList = this.pTTTList.concat();
      }
    },
    gobChangeCondition(pObj) {
      Object.assign(AnalyticsPublic.conditions, pObj);
      StateHandler.savePublic({ conditions: pObj });
      BaseLib.postMessage('msg-change-condition', pObj);
      this.$emit('gob-change-condition', pObj);
      this.$emit('gob-change-any', 'condition');
    },
    gobChangeDate(pObj) {
      AnalyticsPublic.selectedDate = pObj;
      StateHandler.savePublic({ selectedDate: pObj });
      BaseLib.postMessage('msg-change-date', pObj);
      this.$emit('gob-change-date', pObj);
      this.$emit('gob-change-any', 'date');
    },
  },
  beforeCreate() {
    StateHandler.loadPublic();
  },
  mounted() {
    this.fetchList();
  },
};
</script>

<style scoped>
/* 外层盒子样式 */
.filter {
  display: flex;
  height: 56px;
  padding: 10px 12px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);

  position: relative;
  width: 100%;
  background-color: #ffffff;
  z-index: 9;
}

/* app样式 */
.filter-content {
  padding: 0 8px;
}

.filter-content .ivu-btn {
  padding: 0 0 2px 5px;
}

.filter-appselecter {
  width: 167px;
}

.filter-appselecter-ctrl .filter-appselecter img,
.filter-appselecter-item .filter-appselecter img,
.filter-appselecter .app-icon,
.filter-appselecter .filter-appselecter-ctrl img,
.filter-appselecter .filter-appselecter-item img {
  border-radius: 50%;
  width: 28px;
  height: 28px;
  position: absolute;
  top: 3px;
  left: 3px;
}

.filter-appselecter-ctrl span .filter-appselecter span,
.filter-appselecter-item .filter-appselecter span,
.filter-appselecter .filter-appselecter-ctrl span span,
.filter-appselecter .filter-appselecter-item span,
.filter-appselecter .text-ellipsis {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.filter-appselecter-ctrl {
  position: relative;
  width: 100%;
  height: 36px;
  padding-right: 12px !important;
}

.filter-appselecter-ctrl > span {
  width: 100%;
}

.filter-appselecter-ctrl span span {
  margin-left: 20px;
  float: left;
  width: 99px;
  text-align: left;
  color: #464c5b;
  font-weight: 700;
}

.filter-appselecter-ctrl span i {
  float: right;
  padding: 4px 0;
}

.filter-appselecter-list {
  max-height: 320px;
  overflow-y: auto;
}

.filter-appselecter-item {
  position: relative;
}

.filter-appselecter-item.ivu-dropdown-item {
  padding-bottom: 10px;
  margin-bottom: 5px;
}

.filter-appselecter-item span {
  margin-left: 16px;
  width: 100%;
}

/* 平台样式 */
.filter-platform {
  min-width: 120px;
  margin-left: 8px;
}

.filter-platform-ctrl {
  width: 100%;
  height: 36px;
}

.filter-platform-list {
  width: 120px;
}

.filter-platform-list .ivu-checkbox-wrapper {
  display: block;
  height: 30px;
}

.filter-platform-list .ivu-checkbox {
  padding-top: 6px;
}

.filter-platform .ivu-dropdown-item {
  overflow: hidden;
}

.filter-platform-item {
  margin: 10px 6px !important;
}

.filter-platform-icon {
  color: #3091f2;
  font-size: 28px !important;
  margin-right: 6px;
}

.tm-platform-icon {
  margin: 0 3px;
}

.filter-right {
  /* position: absolute;
    right: 0; */
  width: 100%;
}

.filter-right > div {
  /* display: inline-block; */
  float: right;
}
</style>
